



import { defineComponent, ref } from "@vue/composition-api";
import { EmailCategory } from "@scrile/api-provider/dist/api/EmailSettingsProvider";
import providers from "@/lib/api";
import config from "@/config";
import router from "@/router";
import { FormValues } from "@/types";
import EmailNotificationsView from "./components/EmailNotificationsView.vue";

export default defineComponent({
  name: "PageEmailNotificationsSettings",
  components: { EmailNotificationsView },
  setup() {
    const loading = ref(true);
    const token = ref("");
    const values = ref<FormValues>({ incomingMessages: true, goingLive: true, newPosts: true });

    const getValues = async () => {
      token.value = await providers.EmailSettingsProvider.generateToken();
      const { settings } = await providers.EmailSettingsProvider.find({ token: token.value });
      values.value = {
        incomingMessages: settings[EmailCategory.UNREAD_MESSAGES],
        goingLive: settings[EmailCategory.PUBLIC_LIVECHAT],
        newPosts: settings[EmailCategory.NEW_POSTS],
      };
    };

    const onSubmit = async (cb: Function) => {
      try {
        const settings = {
          [EmailCategory.UNREAD_MESSAGES]: values.value.incomingMessages,
          ...(config.featureGoLive ? { [EmailCategory.PUBLIC_LIVECHAT]: values.value.goingLive } : {}),
          [EmailCategory.NEW_POSTS]: values.value.newPosts,
        };
        const data = {
          token: token.value,
          settings,
        };
        await providers.EmailSettingsProvider.update({ data });
        await router.back();
      } finally {
        cb();
      }
    };

    getValues().finally(() => (loading.value = false));

    return { loading, values, onSubmit };
  },
});
